import { combineReducers } from 'redux';


// reducer import
import userReducer from './userReducer';
import feedbackReducer from './feedbackReducer';
import serviceReducer from './service';
import bulletinsReducer from './bulletinsReducer';

import faqsReducer from './faqsReducer';

//
import searchReducer from './searchReducer';
import mapReducer from './mapReducer';
import slicesReducer from './slices';
import aboutReducer from './aboutReducer';
import shareReducer from './shareReducer';
import documentsReducer from './documentsReducer';
import contactReducer from './contactReducer';
import auditReducer from './signatureReducer';

// import servicesReducer from './service';


// ==============================|| COMBINE REDUCER ||============================== //



const rootReducer = combineReducers({
    account: userReducer,
    share: shareReducer,
    feedback: feedbackReducer,
    service: serviceReducer,
    // services: servicesReducer,
    bulletins: bulletinsReducer,
    about: aboutReducer,
    //
    faqs: faqsReducer,
    documents: documentsReducer,
    contact: contactReducer,
    signature: auditReducer,    
    // 全局搜索
    search: searchReducer,
    // 網站地圖
    map: mapReducer,
    slices: slicesReducer
});


export default rootReducer;
